export const UPDATE_PERMISSION_MUTATION = `
  mutation UpdatePermission($id: Int!, $input: permissions_set_input!) {
    update_permissions_by_pk(pk_columns: {id: $id}, _set: $input) {
      id
      role
      screen
      company_id
      can_create
      can_edit
      can_view
      can_delete
    }
  }
`;

export const CREATE_PERMISSION_MUTATION = `
  mutation CreatePermission($input: permissions_insert_input!) {
    insert_permissions_one(object: $input) {
      id
      role
      screen
      company_id
      can_create
      can_edit
      can_view
      can_delete
    }
  }
`; 